import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { submitprojectMilestoneWork } from "../../../../../../../../redux/project/action";
import { descriptionvalidation } from "../../../../../../../Common/commonvalidation";
import { getPostsById } from "../../../../../../../../redux/posts/action";
import AllTypeFilesUpload from "../../../../../../../Common/Upload/AllTypeFilesUpload";
import AsteriskLabel from "../../../../../../../Common/AsteriskLabel";

export default function ModelSubmitWorkForm({ milestonedata, setASModel }) {
  const path = "Assets/scss/searchcontestparticipate.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const { id } = useParams();
  const [work_sample, setWork_sample] = useState();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung") || "en";
  const [lan, setLan] = useState(laung);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    message: "",
    files: "",
  };

  const validationSchema = Yup.object().shape({
    message: descriptionvalidation,
    files: Yup.mixed().required("A file is required"),
  });

  const handleSubmit = (values) => {
    if (loading) return; // prevent double submit
    setLoading(true);

    const data = {
      ...values,
      files: work_sample?.files,
      milestone_id: milestonedata.id,
      type: 1,
    };

    dispatch(
      submitprojectMilestoneWork(data, (success) => {
        dispatch(getPostsById(id));

        setLoading(false);
        setASModel(false)
      })
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className="project-details">
          <div>
            <div className="form-group">
              <label>Description <AsteriskLabel/></label>
              <Field
                as="textarea"
                className="form-control"
                name="message"
                placeholder="Enter description here"
              />
              <ErrorMessage name="message" component="div" className="error" />
            </div>

            <div>
              <label>Add files <AsteriskLabel/></label>
              <AllTypeFilesUpload
                formik={formik}
                setWork_sample={setWork_sample}
                selectedfiles={work_sample?.files}
              />
              <ErrorMessage name="files" component="div" className="error" />
            </div>

            <div className="entry-btn mb-0 aligm-items-center">
              <button
                type="button"
                className="btn w-auto"
                onClick={() => navigate(-1)}
                disabled={loading} // optional, prevent navigation during submit
              >
                Cancel
              </button>

              <button type="submit" className="btn w-auto" disabled={loading}>
                {loading ? (
                  <>
                    Submitting...
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </>
                ) : (
                  <>
                    Submit Work
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                      alt=""
                    />
                  </>
                )}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
